import React, { useState, useEffect, useLayoutEffect, useRef, useMemo, useCallback } from "react";
import parse, { domToReact } from "html-react-parser";
import { usePsChat, MESSAGE_SENT } from '../../../context/PsChatMessageContext';
import { useJob } from "../../../context/JobContext";
import { useAgreement } from "../../../context/AgreementContext";
import { fetchAvatars, useUserRole, useUserId, truncateJobTitle, dateToUnixTimestamp, formatUnixDate, formatUnixFullDate, formatUnixFullTime, formatUnixSmart, playNotificationSound } from "../../../util_functions/helpers";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import {
  FaBriefcase,
  FaAngleLeft,
  FaRegCalendarAlt,
  FaPhoneAlt,
  FaVideo,
  FaMicrophone,
  FaSearch,
  FaEllipsisH,
  FaArrowRight,
} from "react-icons/fa";
import { IoChatboxEllipsesOutline } from "react-icons/io5";
import { PiPaperPlaneRightFill } from "react-icons/pi";
import DOMPurify from "dompurify";
import BlockAlert from "./BlockAlert";
import config from "../../../config/config";
import axios from "axios";
import { Button } from "antd";
import { v4 as uuidv4 } from "uuid";

const FSInbox = () => {
  const userId = useUserId();
  const userRole = useUserRole();

  const imgUrl = config.PROFILE_IMAGES_URL;
  const defaultAvatar = config.AVATAR_DEFAULT_URL;
  const { state, dispatch, fetchMessages } = usePsChat();
  const { selectedJob, fetchJobById } = useJob();
  const jobId = selectedJob?.id ?? "";
  const {
    messages,
    selectedMessageId,
    unreadCounts
  } = state;

  const sortedThreads = useMemo(() => {
    return [...messages].sort((a, b) => {
      const aLast = a.fullMessages?.[a.fullMessages.length - 1];
      const bLast = b.fullMessages?.[b.fullMessages.length - 1];
      const aTime = aLast?.chatMessageTimeStamp ?? 0;
      const bTime = bLast?.chatMessageTimeStamp ?? 0;
      return bTime - aTime;
    });
  }, [messages]);

  const { messageId } = useParams();
  const [text, setText] = useState("");
  const [chatInfoPane, setChatInfoPane] = useState(true);
  const [showContent, setShowContent] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isAgreementSigned, setIsAgreementSigned] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [notificationsEnabled, setNotificationsEnabled] = useState(false);

  const [shouldScrollToBottom, setShouldScrollToBottom] = useState(false);
  useState(false);

  const [showMeetAndGreet, setShowMeetAndGreet] = useState(true);
  const [showScheduler, setShowScheduler] = useState(false);

  const [isMeetAndGreetSet, setMeetAndGreetSet] = useState(false);
  const [isMeetAndGreetConfirmed, setMeetAndGreetConfirmed] = useState(false);
  const [isMeetAndGreetCompleted, setMeetAndGreetCompleted] = useState(false);
  const [isAgreementSet, setAgreementSet] = useState(false);
  const [selectedJobLocation, setSelectedJobLocation] = useState("");
  const [selectedJobDescription, setSelectedJobDescription] = useState("");
  const [workerFirstName, setWorkerFirstName] = useState("");
  const [workerEmail, setWorkerEmail] = useState("");
  const [newMessagesCount, setNewMessagesCount] = useState(0);
  const [lastMessageCount, setLastMessageCount] = useState(0);
  const [isStepModalVisible, setStepModalVisible] = useState(false);
  const [clientImageUrl, setClientImageUrl] = useState(defaultAvatar);
  const [workerImageUrl, setWorkerImageUrl] = useState(defaultAvatar);
  const [mobileView, setMobileView] = useState(
    window.innerWidth <= 768 ? "list" : "desktop"
  );

  const [isSmallMobile, setIsSmallMobile] = useState(
    window.innerWidth <= 480
  );

  const maxTitleLength =
    mobileView !== "desktop" && isSmallMobile ? 40 : 65;

  const [canPlaySound, setCanPlaySound] = useState(false);
  const baseURL = config.API_BASE_URL;

  const navigate = useNavigate();
  const location = useLocation();

  const [scheduleLink, setScheduleLink] = useState("");

  const handleAgreementClick = () => setStepModalVisible(true);

  const selectedThread = messages.find(m => m.id === selectedMessageId);
  const selectedUserThread = selectedThread;
  const userMessages = selectedThread?.fullMessages ?? [];
  const threadJobId = selectedThread?.fullMessages?.[0]?.jobId ?? "";
  const jobTitle = selectedJob?.jobCraftDetails?.jobTitle ?? "";
  const workerId = selectedThread?.workerId ?? "";
  const workerName = selectedThread?.worker ?? "";
  const [isOnline] = useState(true);
  const [showUnreadOnly] = useState(true);

  const userType = useUserRole();

  const messageCount = selectedThread?.fullMessages?.length ?? 0;

  const { agreement, getAgreementByClientWorkerJob } = useAgreement();

  const [agreementFlags, setAgreementFlags] = useState({
    workerSigned: false,
    clientSigned: false,
  });

  const messagesEndRef = useRef(null);
  const newMessagesRef = useRef(null);
  const lastUnreadRef = useRef(null);
  const messagesContainerRef = useRef(null);
  const readMessagesRef = useRef(new Set());
  const observersRef = useRef({});
  const containerRef = messagesContainerRef;
  const listRef = useRef()
  const prevCountRef = useRef(messageCount);
  const prevTotalUnreadRef = useRef(0);
  const initialLoadRef = useRef(false);
  const processedVisibleRef = useRef(false);
  const meetAndGreetScheduleRef = useRef(null);
  const meetAndGreetJoinRef = useRef(null);
  const sendAgreementRef = useRef(null);
   const reviewAgreementRef = useRef(null);

  const now = dateToUnixTimestamp(new Date());

  const unreadIndexes = useMemo(() => {
    return userMessages
      .map((m, idx) => ({ m, idx }))
      .filter(({ m }) => !m.read && m.receiver === userType)
      .map(({ idx }) => idx);
  }, [userMessages, userType]);

  const unreadCount = unreadIndexes.length;

  const firstUnreadIndex = unreadIndexes[0] ?? -1;
  const lastUnreadIndex = unreadIndexes[unreadIndexes.length - 1] ?? -1;

  const ROW_HEIGHT = 80;
  const OVERSCAN_ROWS = 5;

  const items = useMemo(() => {
    const out = [];
    userMessages.forEach((msg, i, arr) => {
      const ts = Number(msg.chatMessageTimeStamp);
      const thisDate = new Date(ts).toDateString();
      const prevDate = i > 0
        ? new Date(Number(arr[i - 1].chatMessageTimeStamp)).toDateString()
        : null;

      if (i === 0 || thisDate !== prevDate) {
        out.push({ type: 'date', timestamp: ts });
      }
      if (i === firstUnreadIndex) {
        out.push({ type: 'unread-marker', count: unreadCount });
      }
      out.push({ type: 'message', message: msg, idx: i });
    });
    return out;
  }, [userMessages, firstUnreadIndex, unreadCount]);

  const firstUnreadMarkerIndex = useMemo(() => {
    return items.findIndex(it => it.type === 'unread-marker');
  }, [items]);

const isMeetGreetSetup = selectedUserThread?.meetAndGreetSet;
const isMeetGreetConfirmed = selectedUserThread?.meetAndGreetConfirmed;
const isMeetGreetDone = isMeetGreetSetup && isMeetGreetConfirmed;

const isClientDone = selectedUserThread?.hasClientConfirmedCompletionSuccess;
const isWorkerDone = selectedUserThread?.hasWorkerConfirmedCompletionSuccess;
const isMeetAndGreetFullyDone = isMeetGreetDone && isClientDone && isWorkerDone;

const hasNoUnread = !userMessages.some(
  m => !m.read && m.receiver === userRole
);

const canJoinMeetAndGreet   = isMeetGreetDone
                          && !isMeetAndGreetFullyDone 
                          && hasNoUnread;

const canReviewAgreement =
  isMeetAndGreetFullyDone &&
  agreement &&
  agreement.workerSigned &&
  !agreement.clientSigned &&
  hasNoUnread;

  useEffect(() => {
    fetchMessages();
  }, [fetchMessages]);

  useEffect(() => {
    const handleFirstInteraction = () => {
      setCanPlaySound(true);
      window.removeEventListener('click', handleFirstInteraction);
    };
    window.addEventListener('click', handleFirstInteraction);
    return () => window.removeEventListener('click', handleFirstInteraction);
  }, []);

  useEffect(() => {
    if (!messageId) {
      dispatch({ type: 'SELECT_MESSAGE', payload: null });
      setShowContent(false);
      return;
    }

    if (messages.length === 0) return;

    const threadExists = messages.some(thread => thread.id === messageId);
    if (threadExists) {
      dispatch({ type: 'SELECT_MESSAGE', payload: messageId });
      setShowContent(true);
      if (window.innerWidth <= 768) {
        setMobileView("content");
      }
    } else {
      navigate('/account/fs-dashboard/inbox', { replace: true });
    }
  }, [messageId, messages, dispatch, navigate]);

  useEffect(() => {
    const totalUnread = Object.values(unreadCounts).reduce(
      (sum, count) => sum + count,
      0
    );

    console.log("[FSInbox] unreadCounts object:", unreadCounts);
    console.log(`[FSInbox] totalUnread: ${totalUnread}`);

    if (!initialLoadRef.current) {
      prevTotalUnreadRef.current = totalUnread;
      initialLoadRef.current = true;
      console.log("[FSInbox] 🔧 initialized prevTotalUnread to", totalUnread);
    } else {
      if (totalUnread > prevTotalUnreadRef.current) {
        console.log("[FSInbox] 📢 unread went up → attempting notification sound");

        if (canPlaySound) {
          playNotificationSound().catch(err => {
            console.debug("🔇 play() blocked:", err.message);
          });
        } else {
          console.debug("🔕 sound skipped – user hasn’t clicked yet");
        }
      }

      prevTotalUnreadRef.current = totalUnread;
    }
  }, [unreadCounts, canPlaySound]);

  useEffect(() => {
    if (showContent && firstUnreadIndex !== -1) {
      newMessagesRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }, [selectedMessageId, showContent, firstUnreadIndex]);

  useEffect(() => {
    if (firstUnreadMarkerIndex !== -1 && listRef.current) {
      listRef.current.scrollToItem(firstUnreadMarkerIndex, 'start');
    }
  }, [selectedMessageId, firstUnreadMarkerIndex]);

  useEffect(() => {
    if (!threadJobId) return;
    fetchJobById(threadJobId);
  }, [threadJobId, fetchJobById]);

  useEffect(() => {
    if (!messageId || !messages.some(thread => thread.id === messageId)) {
      dispatch({ type: 'SELECT_MESSAGE', payload: null });
      setShowContent(false);
      navigate('/account/fs-dashboard/inbox', { replace: true });
    }
  }, [messageId, messages, dispatch, navigate]);

  useEffect(() => {
    if (!workerId || !userId) return;
    const { clientImageUrl, workerImageUrl } = fetchAvatars({
      workerId,
      clientId: userId,
      defaultAvatar,
      imgUrl
    });
    setClientImageUrl(clientImageUrl);
    setWorkerImageUrl(workerImageUrl);
  }, [selectedMessageId, workerId, userId]);

  useEffect(() => {
    if (shouldScrollToBottom && messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
      setShouldScrollToBottom(false);
    }
  }, [shouldScrollToBottom]);

  useEffect(() => {
    function onResize() {
      setMobileView(window.innerWidth <= 768 ? "list" : "desktop");
      setIsSmallMobile(window.innerWidth <= 480);
    }
    window.addEventListener("resize", onResize);
    onResize();
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useLayoutEffect(() => {
    if (showContent && firstUnreadIndex !== -1) {
      newMessagesRef.current?.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
  }, [showContent, selectedMessageId, firstUnreadIndex]);

  useEffect(() => {
    if (!showContent) return;
    const container = messagesContainerRef.current;
    if (!container) return;

    if (!showScheduler && meetAndGreetScheduleRef.current) {
      meetAndGreetScheduleRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      return;
    }

    const seen = new Set();
    const newlyVisibleUnreadIds = new Set();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio === 1) {
            const id = entry.target.dataset.messageId;
            if (id && !seen.has(id)) {
              seen.add(id);
              newlyVisibleUnreadIds.add(id);
              readMessagesRef.current.add(id);
              console.log('[📬 fully visible unread]', id);
              console.log('[📬 fully visible unread—and stashed in ref] ', id);
            }
            observer.unobserve(entry.target);
          }
        });

        if (newlyVisibleUnreadIds.size > 0) {
          console.log(
            `[📬 Newly visible unread count] ${newlyVisibleUnreadIds.size}`
          );
          newlyVisibleUnreadIds.clear();
        }
      },
      { root: container, threshold: 1.0 }
    );

    const observeNew = () => {
      container.querySelectorAll('.message-item.incoming').forEach(el => {
        const id = el.dataset.messageId;
        const isUnread = !!el.querySelector('.unread-indicator');
        if (id && isUnread && !seen.has(id)) {
          observer.observe(el);
        }
      });
    };

    observeNew();

    container.addEventListener('scroll', observeNew);

    return () => {
      container.removeEventListener('scroll', observeNew);
      observer.disconnect();
    };
  }, [showContent, selectedMessageId, showScheduler, userMessages.length]);


  useEffect(() => {
  if (canJoinMeetAndGreet) {
    meetAndGreetJoinRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}, [canJoinMeetAndGreet]);

useEffect(() => {
  if (canReviewAgreement) {
    reviewAgreementRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}, [canReviewAgreement]);


  useEffect(() => {
    console.log(
      `[PSInbox] ▶️ effect for selectedMessageId:`,
      selectedMessageId
    );
    return () => {
      console.log(
        '— flushing IDs:',
        Array.from(readMessagesRef.current)
      ); console.log(
        `[PSInbox] 🔄 cleanup for selectedMessageId:`,
        selectedMessageId,
        '— flushing IDs:',
        Array.from(readMessagesRef.current)
      );
      const ids = Array.from(readMessagesRef.current);
      if (ids.length > 0) {
        axios
          .patch(`${baseURL}/v1/messages/markReadBulk/${selectedMessageId}`, ids)
          .catch(err => console.error("Persisting reads failed:", err));
        readMessagesRef.current.clear();
      }
    };
  }, [selectedMessageId]);

  useEffect(() => {
    if (!selectedThread || !jobId) return;

    console.log("[FSInbox] → fetching agreement", {
      userRole,
      userId,
      jobId,
      workerId,
    });

    getAgreementByClientWorkerJob(userRole, userId, jobId, workerId)
      .then((agreement) => {
        console.log("[FSInbox] ← agreement response:", agreement);
        console.log(
          "[FSInbox]    workerSigned:", agreement.workerSigned,
          "clientSigned:", agreement.clientSigned
        );
        setIsAgreementSigned(agreement.workerSigned && agreement.clientSigned);
      })
      .catch((err) => {
        console.error("[FSInbox] ✖ error fetching agreement:", err);
      });
  }, [selectedThread, jobId, userRole, userId, workerId]);

  const adjustMessageType = (message, userType) =>
    message.sender === userType
      ? "outgoing"
      : "incoming";

  const handleThreadClick = id => {
    dispatch({ type: 'SELECT_MESSAGE', payload: id });
    setShowContent(true);
    if (mobileView !== "desktop") setMobileView("content");
    navigate(`/account/fs-dashboard/inbox/${id}`);
  };

  const getNextStep = () => {
    if (!isMeetAndGreetSet) {
      return "Please set up a meet and greet session.";
    } else if (isMeetAndGreetSet && !isMeetAndGreetConfirmed) {
      return "Waiting for confirmation of the meet and greet session.";
    } else if (
      isMeetAndGreetSet &&
      isMeetAndGreetConfirmed &&
      !isMeetAndGreetCompleted
    ) {
      return "Meet and greet confirmed. Awaiting completion of the session.";
    } else if (
      isMeetAndGreetSet &&
      isMeetAndGreetConfirmed &&
      isMeetAndGreetCompleted &&
      !isAgreementSet
    ) {
      return "Meet and greet completed. It's time to set up the agreement.";
    }
    return "All steps completed.";
  }

  const handleBackClick = () => {
    setShowContent(false);
    if (mobileView !== "desktop") setMobileView("list");
  };

  const handleInfoClick = () => {
    if (mobileView !== "desktop") {
      setMobileView("info");
      return;
    }
    setChatInfoPane(!chatInfoPane);
  };

  const handleCloseClick = () => {
    if (mobileView !== "desktop") {
      setMobileView("content");
      return;
    }
    setChatInfoPane(false);
    setShowContent(true);
  };

  const handleScroll = (e) => {
    const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;
    if (scrollHeight - scrollTop === clientHeight) {
    }
  };

  const fsSendMessage = async () => {
    if (!text.trim() || !selectedMessageId) return;

    const newMsg = {
      text,
      chatMessageTimeStamp: now,
      sender: userType,
      receiver: userType === "client" ? "worker" : "client",
      jobId,
      read: false,
    };

    const updatedThreads = state.messages.map(thread => {
      if (thread.id !== selectedMessageId) return thread;
      return {
        ...thread,
        fullMessages: [...thread.fullMessages, newMsg],
      };
    });

    dispatch({ type: "SET_MESSAGES", payload: updatedThreads });

    setText("");
    setShouldScrollToBottom(true);

    try {
      await axios.post(
        `${baseURL}/v1/messages/addChatMessage/${selectedMessageId}`,
        newMsg
      );
    } catch (err) {
      console.error("Error sending message:", err);
    }
  };

  const isClientReplyToWorker = (fullMessages) => {
    if (fullMessages.length >= 2) {
      return (
        fullMessages[0].sender === "worker" &&
        fullMessages[1].sender === "client"
      );
    }
    return false;
  };

  const handleReopen = (state) => {
    setShowAlert(state);
  };

  const toggleAlert = () => {
    setShowAlert(!showAlert);
  };

  const renderMessageStatus = (message) => {
    if (message.sender === userType) {
      const statusClass = message.read
        ? "message-status-read"
        : "message-status-unread";
      return (
        <span className={`message-status ${statusClass}`}>
          {message.read
            ? "Read"
            : "Delivered"
          }
        </span>
      );
    }
    return null;
  };

  const cleanLatestTextMessage = (htmlString) => {
    htmlString = htmlString.replace(/<(script|style).*?>.*?<\/\1>/gi, "");
    const textArea = document.createElement("textarea");
    textArea.innerHTML = htmlString;
    htmlString = textArea.value;
    htmlString = htmlString.replace(/<[^>]*>/g, "");
    htmlString = htmlString.replace(/\s+/g, " ");
    htmlString = htmlString.trim();
    return htmlString.substring(0, 25);
  };

  const sanitizeAndParseHtml = (htmlString) => {
  const cleanHtml = DOMPurify.sanitize(htmlString);

  const options = {
    replace: ({ name, attribs, children }) => {
      if (!attribs) return;

      if (name === 'button' && attribs.class === 'view-profile-btn') {
        return (
          <button
            className="view-profile-btn"
            onClick={handleConfirmAttendance}
          >
            {domToReact(children, options)}
          </button>
        );
      }

      if (name === 'p') {
        return <p className="message-text">{domToReact(children, options)}</p>;
      }

      if (name === 'a') {
        const { class: _class, ...rest } = attribs;
        return (
          <a
            className="message-text"
            className={_class} 
            {...rest}
          >
            {domToReact(children, options)}
          </a>
        );
      }
    },
  };

  return parse(cleanHtml, options);
};


  const handleJobTitleClick = () => {
    if (!jobId) return;
    window.open(
      `/account/ps-dashboard/job-listings/open/${jobId}`,
      "_blank"
    );
  };

  const toggleNotifications = () => {
    setNotificationsEnabled((prev) => !prev);
  };

  const handleConfirmAttendance = useCallback(async () => {
    console.log("handleConfirmAttendance Invoked");
    if (!selectedMessageId) return;

    const details = selectedUserThread?.meetAndGreetDetails || {};
    const sessionName = `session_${Math.random().toString(16).slice(2, 10)}`;

    const payload = {
      meetAndGreetConfirmed: true,
      meetingConfirmedBy: userId,
      meetAndGreetSessionName: sessionName,
    };

    console.log("payload to patch:", payload);

    try {
      const patchRes = await axios.patch(
        `${baseURL}/v1/messages/confirm-invite/${selectedMessageId}`,
        payload
      );
      console.log("🎉 Meet & Greet confirmed:", patchRes.data);

      const newMsg = {
        chatMessageTimeStamp: now,
        text: `🎉 Meet & Greet confirmed for <strong>${details.meetAndGreetDate}</strong> at <strong>${details.meetAndGreetTime}</strong>.`,
        sender: userRole,
        receiver: userRole === "worker" ? "client" : "worker",
        jobId,
        read: false,
      };

      const postRes = await axios.post(
        `${baseURL}/v1/messages/addChatMessage/${selectedMessageId}`,
        newMsg
      );
      console.log("📝 Chat message posted:", postRes.data);
    } catch (err) {
      console.error("❌ Error confirming Meet & Greet:", err);
    }
  }, [
    selectedMessageId,
    selectedUserThread,
    userId,
    userRole,
    jobId,
    baseURL,
    now
  ]);

  const cleanJobDescription = (htmlString) => {
    htmlString = htmlString.replace(/<(script|style).*?>.*?<\/\1>/gi, "");

    const entitiesMap = {
      "&nbsp;": " ",
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'",
    };

    htmlString = htmlString.replace(/&[a-zA-Z0-9#]+;/g, (entity) => {
      return entitiesMap[entity] || entity;
    });

    htmlString = htmlString
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim();

    return htmlString;
  };

  const navigateToAgreementSetup = () => {
    const cleanedJobDescription = cleanJobDescription(selectedJobDescription);

    // const agreementSetupState = {
    //   messageId: userId,
    //   clientId: clientId,
    //   client: clientName,
    //   jobId: jobId,
    //   jobLocation: selectedJobLocation,
    //   jobTitle: jobTitle,
    //   jobDescription: cleanedJobDescription,
    // };

    // navigate("/account/ps-dashboard/agreement-setup", {
    //   state: agreementSetupState,
    // });
  };

  const handleJoinMeetAndGreet = () => {
    const preferredMethod = selectedUserThread.meetAndGreetDetails.meetAndGreetPreferredMethod;
    const sessionName = selectedUserThread.meetAndGreetSessionName;
    const threadId = selectedUserThread.id;

    console.log("handleJoinMeetAndGreet → threadId:   ", threadId);
    console.log("handleJoinMeetAndGreet → preferredMethod:", preferredMethod);
    console.log("handleJoinMeetAndGreet → sessionName:   ", sessionName);

    const userId = selectedUserThread.clientId;

    const userName = selectedUserThread.client;

    if (!sessionName) {
      console.error("No session name available for navigation.");
      return;
    }
    navigate(
      `/account/fs-dashboard/meeting/${preferredMethod}/${sessionName}/${threadId}`,
      { replace: false }
    );
  };

  return (
    <div className="inbox-container">
      <div className="message-list-scroll-wrapper"
        style={{
          display:
            mobileView === "desktop" || mobileView === "list"
              ? undefined
              : "none",
        }}>
        <div className="message-list">
          <div className="message-list-header">
            <div className="header-controls">
              <div className="search-wrapper">
                <FaSearch className="message-search-icon" />
                <input
                  type="search"
                  placeholder="Search messages…"
                />
              </div>
              <div className="sort-mark-container">
                <button className="mark-read-btn">
                  Mark read
                </button>
                <select
                  className="sort-menu"
                >
                  <option value="newest">All</option>
                  <option value="unread">Read</option>
                  <option value="unread">Unread</option>
                </select>

                <button className="new-msg-btn">
                  + New Message
                </button>
              </div>
            </div>
          </div>

          <div className="message-list-items">
            {sortedThreads.length === 0 ? (
              <div className="no-messages-placeholder">
                <img
                  src="/images/no_results_found.png"
                  alt="No results found"
                  className="no-messages-image"
                />
                <p>No conversations yet.</p>
              </div>
            ) : (
              <ul>
                {sortedThreads.map(thread => {
                  const {
                    id,
                    client: clientName,
                    worker: workerName,
                    fullMessages = []
                  } = thread;

                  const displayName = userRole === "client" ? workerName : null;

                  const [firstName, lastName] = displayName.split(" ");
                  const lastInitial = lastName ? lastName.charAt(0) : "";

                  const lastMsg = fullMessages[fullMessages.length - 1] || {};
                  const latestMessageTimestamp = lastMsg.chatMessageTimeStamp;
                  const rawText = lastMsg.text || "";
                  const cleanedLatestMessage = cleanLatestTextMessage(rawText);
                  const unreadCount = unreadCounts[id] || 0;

                  return (
                    <li
                      key={id}
                      onClick={() => handleThreadClick(id)}
                      className={id === selectedMessageId ? "inbox-selected-message" : ""}
                    >
                      <div className="message-list-thumbnail">
                        {workerName.charAt(0)}
                      </div>
                      <div className="message-list-info">
                        <div className="message-list-user">
                          <h3>
                            {firstName}
                            {lastInitial && ` ${lastInitial}.`}
                          </h3>
                          {unreadCount > 0 && (
                            <span className="unread-count">
                              {unreadCount > 99 ? '99+' : unreadCount}
                            </span>
                          )}

                          <span className="last-message-date">
                            {formatUnixSmart(latestMessageTimestamp)}
                          </span>
                        </div>
                        <div className="latest-message">
                          {cleanedLatestMessage}…
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
        </div>
      </div>
      <div
        className="message-content"
        style={{
          display:
            mobileView === "desktop" || mobileView === "content"
              ? undefined
              : "none",
        }}
      >
        <div className="message-content-container">
          {!showContent ? (
            <div className="chat-message-placeholder">
              <div className="message-content-header">
                <h2>Welcome to your Inbox</h2>
              </div>
              <p>Select a message thread to view the conversation.</p>
              <img src="/images/inbox-illustration.png" alt="Inbox Illustration" />
            </div>
          ) : (
            <div className="messageArea">
              <div className="message-content-header">
                <div className="message-back-icon">
                  {mobileView !== "desktop" && showContent && (
                    <FaAngleLeft onClick={handleBackClick} />
                  )}
                </div>
                {selectedUserThread && (
                  <div className="chat-client-header-container">
                    <div className="avatar-call-options">
                      <div className="avatar-status-wrapper">
                        <div className="client-avatar-name">
                          <img
                            src={workerImageUrl}
                            onError={e => {
                              e.currentTarget.onerror = null;
                              e.currentTarget.src = defaultAvatar;
                            }}
                            alt="User Avatar"
                            className="client-header-incoming"
                          />
                          <span>{selectedUserThread.worker.split(" ")[0]}</span>
                        </div>
                        <div className="user-status-indicator">
                          <span
                            className={`status-circle ${isOnline ? 'online' : 'offline'}`}
                            title={isOnline ? 'Online' : 'Offline'}
                          ></span>
                          <span className="status-text">{isOnline ? 'Online' : 'Offline'}</span>
                        </div>
                      </div>
                      <div className="calling-options-bar">
                        <button className="calling-option-btn" title="Voice Call">
                          <FaPhoneAlt />
                        </button>
                        <button className="calling-option-btn" title="Video Call">
                          <FaVideo />
                        </button>
                        {mobileView !== "desktop" && (
                          <button onClick={handleInfoClick}>
                            <FaArrowRight /></button>
                        )}
                      </div>
                    </div>
                    <div className="chat-header-container">
                      <div className="job-inbox-title">
                        <span className="job-fa-icon">
                          <FaBriefcase />
                        </span>
                        <span
                          className="job-title-text"
                          onClick={handleJobTitleClick}
                        >
                          {truncateJobTitle(jobTitle, maxTitleLength)}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {userId && (
                <div className="inbox-chat-messages-container">
                  <div className="inbox-chat-messages" ref={messagesContainerRef} onScroll={handleScroll}>
                    {selectedUserThread && userMessages.map((msg, index, array) => {
                      const isFirstUnread =
                        index ===
                        array.findIndex(
                          (m) => !m.read && m.receiver === userType
                        );

                      const unreadCount = array.filter(
                        m => !m.read && m.receiver === userType
                      ).length;


                      const messageDate = new Date(msg.chatMessageTimeStamp).toDateString();
                      const thisDate = new Date(msg.chatMessageTimeStamp).toDateString();
                      const prevDate = index > 0
                        ? new Date(array[index - 1].chatMessageTimeStamp).toDateString()
                        : null;
                      const shouldShowDateHeader = index === 0 || thisDate !== prevDate;

                      return (
                        <React.Fragment key={index}>
                          {shouldShowDateHeader && (
                            <div className="date-header">
                              <FaRegCalendarAlt className="date-icon" />
                              <span className="date-text">
                                {formatUnixFullDate(msg.chatMessageTimeStamp)}
                              </span>
                            </div>
                          )}

                          {index === firstUnreadIndex && (
                            <div ref={newMessagesRef} className="new-message-indicator">
                              <IoChatboxEllipsesOutline className="new-msg-icon" />
                              {unreadCount === 1
                                ? 'New Message'
                                : 'New Messages'}
                            </div>
                          )}
                          {isFirstUnread && unreadCounts[userId] > 0 && (
                            <div className="new-message-indicator">
                              {unreadCounts[userId]} New Message
                              {unreadCounts[userId] > 1 ? "s" : ""}
                            </div>
                          )}
                          {index === lastUnreadIndex && (
                            <div ref={lastUnreadRef} style={{ height: '1px' }} />
                          )}
                          <div
                            className={`message-item ${adjustMessageType(
                              msg,
                              userType
                            )}`}
                            data-message-id={msg.messageId}
                            style={{ position: 'relative' }}
                          >
                            {!msg.read && msg.receiver === userType && (
                              <span
                                className="unread-indicator"
                              />
                            )}

                            <div className="message-wrapper">
                              <div className="message-text-wrapper">
                                <span className="message-text">
                                  {sanitizeAndParseHtml(msg.text)}
                                </span>
                              </div>
                            </div>
                            <div className="message-time-wrapper">
                              <span
                                className={`message-time ${adjustMessageType(
                                  msg,
                                  userType
                                )}-time`}
                              >
                                {formatUnixFullTime(msg.chatMessageTimeStamp)}
                                {renderMessageStatus(msg)}
                              </span>
                            </div>
                          </div>
                          {/* <div className="avatar-container">
                            {adjustMessageType(msg, userType) === 'incoming' && (
                              <div className="message-sender">
                                <img
                                  src={workerImageUrl}
                                  onError={e => {
                                    e.currentTarget.onerror = null;
                                    e.currentTarget.src = defaultAvatar;
                                  }}
                                  alt="User Avatar"
                                  className="avatar-incoming"
                                />
                                <span>{selectedUserThread.worker.split(" ")[0]}</span>
                              </div>
                            )}

                            {adjustMessageType(msg, userType) === 'outgoing' && (
                              <div className="message-receiver">
                                <span>
                                  {selectedUserThread.client.split(" ")[0]}
                                </span>
                                <img
                                  src={clientImageUrl}
                                  onError={e => {
                                    e.currentTarget.onerror = null;
                                    e.currentTarget.src = defaultAvatar;
                                  }}
                                  alt="User Avatar"
                                  className="avatar-outgoing"
                                />
                              </div>
                            )}
                          </div> */}
                        </React.Fragment>
                      );
                    })}

                    {selectedUserThread &&
                      isClientReplyToWorker(userMessages) &&
                      showMeetAndGreet &&
                      selectedUserThread.meetAndGreetSet === false && (
                        <div className="inbox-meet-and-greet"
                          ref={meetAndGreetScheduleRef}>
                          <div className="meet-span-wrapper">
                            <span>ℹ️ Meet &amp; Greet Setup</span>

                            <button onClick={() => setShowScheduler(true)}>
                              Schedule
                            </button>
                          </div>
                          <div className="meet-greet-close">
                            <span onClick={() => setShowMeetAndGreet(false)}>
                              ×
                            </span>
                          </div>
                        </div>
                      )}
                    {canJoinMeetAndGreet && (
                        <div className="inbox-meet-and-greet"
                          ref={meetAndGreetJoinRef}>
                          <div className="meet-span-wrapper">
                            <span>🤝 Meet &amp; Greet time</span>
                            <button onClick={handleJoinMeetAndGreet}>
                              Join Session
                            </button>
                          </div>
                        </div>
                      )}

                    {canReviewAgreement && (
                        <div className="inbox-meet-and-greet" ref={reviewAgreementRef}>
                          <div className="meet-span-wrapper">
                            <span className="agreement-helper">
                              ℹ️ Agreement submitted
                            </span>
                            <button
                              onClick={() =>
                                navigate(
                                  `/account/fs-dashboard/manage-workers/agreements`
                                )
                              }
                            >
                              Review Agreement
                            </button>
                          </div>
                        </div>
                      )}

                    <div ref={messagesEndRef} />
                  </div>

                  <div className="chat-input-container">
                    <textarea
                      className="chat-message-input-textarea"
                      value={text}
                      onChange={(e) => setText(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && !e.shiftKey) {
                          e.preventDefault();
                          fsSendMessage();
                        }
                      }}
                      placeholder="Type your message..."
                    ></textarea>
                    <button className="chat-send-button" onClick={fsSendMessage}>
                      <PiPaperPlaneRightFill />
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="chat-info-pane"
        style={{
          display:
            mobileView === "desktop" || mobileView === "info"
              ? undefined
              : "none",
        }}>
        <div className="chat-info-header">
          <h2>Chat Info</h2>
          {mobileView !== "desktop" && (
            <span className="close-info" onClick={handleCloseClick}>X</span>
          )}
        </div>

        {selectedUserThread && (
          <div className="chat-info-details">
            <div className="user-info">
              <div className="user-circle">
                <img
                  src={workerImageUrl}
                  onError={e => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = defaultAvatar;
                  }}
                  alt="User Avatar"
                  className="avatar"
                />
              </div>
              <div className="userName">{selectedUserThread.worker}</div>
            </div>

            {isMeetAndGreetSet && isMeetAndGreetConfirmed ? (
              isMeetAndGreetCompleted ? (
                !isAgreementSet ? (
                  <>
                    <div className="agreement-info">
                      <h4>Finalize agreement</h4>
                      <div className="agreement-info-content">
                        <p>
                          To set up care with the client, first agree on the
                          rate and schedule via chat, then offer a formal
                          agreement.
                        </p>
                        <Button
                          className="agreement-info-content-button"
                        // onClick={navigateToAgreementSetup}
                        >
                          Send agreement
                        </Button>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="agreement-info">
                    <strong>All steps completed. Agreement set.</strong>
                  </div>
                )
              ) : (
                <div className="agreement-prep-info">
                  <strong>Next step:</strong> {getNextStep()}
                </div>
              )
            ) : (
              <div className="agreement-prep-info">
                <strong>Next step:</strong> {getNextStep()}
              </div>
            )}
          </div>
        )}

        {chatInfoPane && (
          <>
            <ul className="chat-action-list">
              <li className="notification-toggle">
                <span className="icon">🔔</span>
                <div className="toggle-container" onClick={toggleNotifications}>
                  <span>
                    {notificationsEnabled
                      ? "Disable Notifications"
                      : "Enable Notifications"}
                  </span>
                  <div
                    className={`toggle-switch ${notificationsEnabled ? "active" : ""
                      }`}
                  >
                    <div className="toggle-circle"></div>
                  </div>
                </div>
              </li>
              <li onClick={toggleAlert}>
                <span className="icon">🚫</span>
                Block Calls
                {showAlert && (
                  <BlockAlert
                    isOpen={showAlert}
                    onClose={() => setShowAlert(false)}
                  />
                )}
              </li>
              <li>
                <span className="icon">👤</span>
                Block User
              </li>
              <li>
                <span className="icon">⚠️</span>
                Report
              </li>
              <li>
                <span className="icon">📦</span>
                Archive Chat
              </li>
            </ul>
          </>
        )}
      </div>
    </div>
  );

};

export default FSInbox;
